import { render, staticRenderFns } from "./TopSearch.vue?vue&type=template&id=10040ed0&scoped=true&"
import script from "./TopSearch.vue?vue&type=script&lang=js&"
export * from "./TopSearch.vue?vue&type=script&lang=js&"
import style0 from "./TopSearch.vue?vue&type=style&index=0&id=10040ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10040ed0",
  null
  
)

export default component.exports